import { locales } from '@americanexpress/conditional-features';
import {
  BASE_DYNATRACE_URL,
  TRACKING_IDS,
  INTL_DYNATRACE_PATH,
} from '../helpers/constants';

const getDynatraceDetails = (getActiveLocale) => {
  const activeLocale = getActiveLocale;
  const dynatrace = { src: '' };
  if (activeLocale) {
    if (activeLocale === locales.EN_US) {
      dynatrace.src = `${BASE_DYNATRACE_URL}/${TRACKING_IDS[activeLocale]}.js`;
    } else {
      dynatrace.src = `${BASE_DYNATRACE_URL}/${INTL_DYNATRACE_PATH}/${TRACKING_IDS[activeLocale]}_complete.js`;
    }
  }
  return dynatrace;
};

export default getDynatraceDetails;
